import React, { useEffect, useState } from "react";
import { useHistory, Link } from "react-router-dom";
import { Button } from "react-bootstrap";
import { useSelector } from "react-redux";

export default function Header() {
    const [isLoggedIn, setIsLoggedIn] = useState(false);
    const history = useHistory();
    const userData = useSelector((state) => state.user);

    // Track Redux login state
    useEffect(() => {
        if (Object.keys(userData.user).length > 0) {
            setIsLoggedIn(true);
        } else {
            setIsLoggedIn(false);
        }
    }, [userData]);

    // Add Google Font and Font Awesome once
    useEffect(() => {
        const googleFont = document.createElement("link");
        googleFont.href =
            "https://fonts.googleapis.com/css2?family=Public+Sans:ital,wght@0,100..900;1,100..900&display=swap";
        googleFont.rel = "stylesheet";

        const fontAwesome = document.createElement("link");
        fontAwesome.href =
            "https://cdn.jsdelivr.net/npm/@fortawesome/fontawesome-free@6.5.2/css/all.min.css";
        fontAwesome.rel = "stylesheet";

        document.head.append(googleFont, fontAwesome);
        return () => {
            document.head.removeChild(googleFont);
            document.head.removeChild(fontAwesome);
        };
    }, []);

    // Redirect function
    const handleLoginRedirect = () => {
        history.push("/login");
    };

    const handleMapRedirect = () => {
        history.push("/map");
    };

    return (
        <header>
            <div className="container">
                <div className="header-inner">
                    {/* Logo + Title */}
                    <div
                        className="header-logo"
                        style={{ display: "flex", alignItems: "center", gap: "12px" }}
                    >
                        <a href="https://nab.gov.pk" onClick={()=>{window.location.href='https://nab.gov.pk'}} className="nab-link">
                            <img
                                style={{width:'80px'}}
                                src="/images/nab_logo.png"
                                className="img-logo"
                                alt="NAB Logo"
                            />
                        </a>
                        <span onClick={()=>{window.location.href='/'}}
                            className="bureau-title"
                            style={{
                                fontWeight: "bold",
                                fontSize: "22px",
                                color: "#222",
                                cursor:'pointer'
                            }}
                        >
              National Accountability Bureau
            </span>
                    </div>

                    {/* Header actions */}
                    <div
                        className="header-actions"
                        style={{ display: "flex", alignItems: "center", gap: "12px" }}
                    >
                        <a
                            href="https://nab.gov.pk/"
                            target="_blank"
                            rel="noopener noreferrer"
                            style={{
                                border: "1px solid #555",
                                padding: "8px 16px",
                                borderRadius: "4px",
                                textDecoration: "none",
                                fontSize: "14px",
                                color: "#333",
                                fontWeight: "500",
                                lineHeight: "1",
                                height: "40px",
                                display: "none",
                                alignItems: "center",
                                justifyContent: "center",
                                backgroundColor: "transparent",
                            }}
                        >
                            Comment
                        </a>



                        {/* Auth Section */}
                        <div className="navbar-nav flex-row align-items-center">
                            {isLoggedIn ? (
                                <button
                                    onClick={handleMapRedirect}
                                    style={{
                                        backgroundColor: "#004080",
                                        color: "#fff",
                                        padding: "8px 16px",
                                        borderRadius: "4px",
                                        fontSize: "14px",
                                        fontWeight: "500",
                                        lineHeight: "1",
                                        height: "40px",
                                        border: "none",
                                        cursor: "pointer",
                                        display:'none'
                                    }}
                                >
                                    Map
                                </button>
                            ) : (
                                <button
                                    onClick={handleLoginRedirect}
                                    style={{
                                        backgroundColor: "#004080",
                                        color: "#fff",
                                        padding: "8px 16px",
                                        borderRadius: "4px",
                                        fontSize: "14px",
                                        fontWeight: "500",
                                        lineHeight: "1",
                                        height: "40px",
                                        border: "none",
                                        cursor: "pointer",
                                        display:'none'
                                    }}
                                >
                                    Login / Register
                                </button>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </header>
    );
}
